module.exports = __webpack_public_path__ + "9dfddba0f589cd605babe58c43df28c9.svg";